import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-acclaim',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Acclaim icon</title><path d="M12.468.186a.7.7 0 0 0-.95 0L1.924 9.193a1.705 1.705 0 0 0-.475 1.095v3.59c0 .358.214.452.475.207l9.601-9.01a.705.705 0 0 1 .95 0l9.603 9.01c.262.245.475.151.475-.207v-3.59a1.71 1.71 0 0 0-.475-1.095zm0 9.783a.705.705 0 0 0-.95 0l-9.595 9.002a1.705 1.705 0 0 0-.475 1.094v3.59c0 .358.214.453.475.208l9.601-9.007a.701.701 0 0 1 .95 0l9.603 9.008c.262.244.475.15.475-.208v-3.59a1.71 1.71 0 0 0-.475-1.094Z"/></svg>`,
    styles: []
})
export class SimpleIconsAcclaimComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#26689A';
    @Input() className: string = 'simple-icons-acclaim'
    constructor() {}
    ngOnInit(): void {}
}
